import { AuthUser } from "../types/auth";

const SESSION_TOKEN_KEY = "session_id_token";

let _idToken: string | null = (() => {
  try { return sessionStorage.getItem(SESSION_TOKEN_KEY); } catch { return null; }
})();

export function setIdToken(token: string | null): void {
  _idToken = token;
  try {
    if (token) sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    else sessionStorage.removeItem(SESSION_TOKEN_KEY);
  } catch { /* SSR / private mode */ }
}

export function getIdToken(): string | null {
  return _idToken;
}

// Auth-State und Profil-Cache für Offline-Modus
const AUTH_STATE_KEY = "auth_state";
const PROFILE_CACHE_KEY = "cached_user_profile";

export function wasAuthenticated(): boolean {
  return localStorage.getItem(AUTH_STATE_KEY) === "authenticated";
}

export function getCachedProfile(): AuthUser | null {
  const v = localStorage.getItem(PROFILE_CACHE_KEY);
  try { return v ? JSON.parse(v) : null; } catch { return null; }
}

export function persistAuthState(profile: AuthUser): void {
  localStorage.setItem(AUTH_STATE_KEY, "authenticated");
  localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify(profile));
}

export function clearAuthState(): void {
  localStorage.removeItem(AUTH_STATE_KEY);
  localStorage.removeItem(PROFILE_CACHE_KEY);
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export function getEmailFromToken(token: string | null): string | null {
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  return (payload?.email as string | undefined) ?? null;
}

// Google-ID-Tokens sind kurzlebig (~1h). Ein abgelaufener Token, der noch im
// sessionStorage liegt, würde beim Laden kurz als "eingeloggt" durchgehen und erst
// nach einem fehlgeschlagenen API-Call (401 → auth:unauthorized) wieder korrigiert
// werden - das erzeugt einen sichtbaren /login-Flicker. Deshalb clientseitig vorab prüfen.
export function isTokenExpired(token: string): boolean {
  const payload = decodeJwtPayload(token);
  const exp = payload?.exp as number | undefined;
  if (!exp) return true;
  return exp * 1000 <= Date.now();
}
